import { render, staticRenderFns } from "./numericalStatistical.vue?vue&type=template&id=0b7ccf65&scoped=true&"
import script from "./numericalStatistical.vue?vue&type=script&lang=js&"
export * from "./numericalStatistical.vue?vue&type=script&lang=js&"
import style0 from "./numericalStatistical.vue?vue&type=style&index=0&id=0b7ccf65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7ccf65",
  null
  
)

export default component.exports